import { ENV_MODE } from "constants/constants";
import { LOCAL_KEY } from "constants/key";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import api from "service/apiService";
import { delay } from "utils";
import { checkIfSwAvailable } from "utils/service-worker";

const SW_RUNNING_INTERVAL = 3000;

const productionConfig = {
	apiKey: "AIzaSyAWCT1GUuKmIzBJCQn5I_FPrMz8G684Mls",
	authDomain: "liberty-technology-co-ltd.firebaseapp.com",
	projectId: "liberty-technology-co-ltd",
	storageBucket: "liberty-technology-co-ltd.appspot.com",
	messagingSenderId: "247290180673",
	appId: "1:247290180673:web:5c86338cff8337d674c2c0",
	measurementId: "G-75J7YWBWSE",
};

const stagingConfig = {
	apiKey: "AIzaSyCPucx9pf8M0wqovtq9oKIyJW9ow5pCDZ8",
	authDomain: "lbtkh-ff97d.firebaseapp.com",
	projectId: "lbtkh-ff97d",
	storageBucket: "lbtkh-ff97d.appspot.com",
	messagingSenderId: "422008269517",
	appId: "1:422008269517:web:5d6c21a9aa4495ee5c9784",
	measurementId: "G-XCMNK20BMR",
};

const isProduction = process.env.REACT_APP_ENV === ENV_MODE.PRODUCTION;

const firebaseApp = initializeApp(
	isProduction ? productionConfig : stagingConfig,
);

export const messaging = (async () => {
	try {
		const isSupportedBrowser = await isSupported();
		if (isSupportedBrowser) {
			return getMessaging(firebaseApp);
		}
		console.log("Firebase not supported this browser");
		return null;
	} catch (err) {
		console.log(err);
		return null;
	}
})();

export const getMessagingToken = async () => {
	const permission = await Notification.requestPermission();
	const msg = await messaging;
	const isSwAvailable = await checkIfSwAvailable({});
	if (permission === "granted" && msg) {
		if (!isSwAvailable) {
			try {
				const registedSw = await navigator.serviceWorker.register(
					"/firebase-messaging-sw.js",
					{
						scope: "/firebase-cloud-messaging-push-scope",
					},
				);
				await delay(SW_RUNNING_INTERVAL);
				try {
					const currentToken = await getToken(msg, {
						serviceWorkerRegistration: registedSw,
					});
					if (localStorage.getItem(LOCAL_KEY.deviceId)) {
						await api.put("/user-devices", {
							agent: navigator.userAgent,
							deviceId: localStorage.getItem(LOCAL_KEY.deviceId),
							token: currentToken,
							os: "",
							osVersion: "",
							appVersion: "",
						});
					}
				} catch (error) {
					console.error("Error while getting token:", error);
				}
			} catch (error) {
				console.error("An error occurred:", error);
			}
		}
	} else {
		console.log("Notification is not allowed");
	}
};
